import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

import './css/main.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
